import api from '@mint-lib/api';

import { USER_ROLES, USER_ROLES_V2 } from '../endpointConstants.js';
import {
  CreateRoleType,
  RolesMetaType,
  RoleType,
  type EditRoleType,
} from './roles.types.js';

export const fetchRolesMeta = (
  isAiHubIncluded: boolean,
  newVersion: boolean,
): Promise<RolesMetaType> => {
  const mainEndpoint = newVersion ? `${USER_ROLES_V2}` : `${USER_ROLES}`;
  const endpoint = isAiHubIncluded
    ? `${mainEndpoint}meta/?is_ai_hub_included=${isAiHubIncluded}`
    : `${mainEndpoint}meta/`;
  return api.get(endpoint).then((data) => data.data);
};

export const createRole = (params: CreateRoleType): Promise<RoleType> => {
  return api.post(USER_ROLES, params).then((data) => data.data);
};

export const createRoleV2 = (params: CreateRoleType): Promise<RoleType> => {
  return api.post(USER_ROLES_V2, params).then((data) => data.data);
};

export const editRole = (role: Partial<EditRoleType>): Promise<RoleType> =>
  api
    .patch(
      `${USER_ROLES}${role.id}/`,
      // Omitting specified keys from the role object
      (({ id, createdAt, usersDetails, isDefault, ...rest }) => rest)(role),
    )
    .then((data) => data.data);

export const editRoleV2 = (role: Partial<EditRoleType>): Promise<RoleType> =>
  api
    .patch(
      `${USER_ROLES_V2}${role.id}/`,
      // Omitting specified keys from the role object
      (({ id, createdAt, usersDetails, isDefault, ...rest }) => rest)(role),
    )
    .then((data) => data.data);

export const deleteRole = (id: number): Promise<void> =>
  api.delete(`${USER_ROLES}${id}/`).then((data) => data.data);
